import { render, staticRenderFns } from "./Brewery.vue?vue&type=template&id=238ba21d&scoped=true&lang=pug&"
import script from "./Brewery.vue?vue&type=script&lang=js&"
export * from "./Brewery.vue?vue&type=script&lang=js&"
import style0 from "./Brewery.vue?vue&type=style&index=0&id=238ba21d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238ba21d",
  null
  
)

export default component.exports